import { axios, getAxiosConfig, ServerAxiosRequestData } from '@config/axios';
import { ApiResponse } from '@interfaces/api';
import Environment from '@config/environment';
import { ProductFeedPayload } from '@interfaces/api/payloads/product-feed-payload';
import { ProductFeedsResponse } from '@interfaces/api/responses/product-feed-response';
import { ProductFeed } from '@interfaces/models/product-feed';

export default class ProductFeedService {
  private static recommendApiBasePath = `${Environment.apiBaseUrl}/recommend`;

  static async getProductFeeds(
    payload: ProductFeedPayload,
    headers: Record<string, string>,
    serverAxiosRequestData?: ServerAxiosRequestData,
  ): Promise<ProductFeedsResponse> {
    const axiosConfig = getAxiosConfig(serverAxiosRequestData);

    const { data } = await axios.post<ProductFeedPayload, ApiResponse<ProductFeedsResponse>>(
      `${ProductFeedService.recommendApiBasePath}/product-feed`,
      payload,
      { ...axiosConfig, headers: { ...axiosConfig?.headers, ...headers } },
    );
    return data;
  }

  static async getSingleProductFeed(
    payload: ProductFeedPayload,
    headers: Record<string, string>,
    feedType: string,
    serverAxiosRequestData?: ServerAxiosRequestData,
  ): Promise<ProductFeed> {
    const axiosConfig = getAxiosConfig(serverAxiosRequestData);

    const { data } = await axios.post<ProductFeedPayload, ApiResponse<ProductFeed>>(
      `${ProductFeedService.recommendApiBasePath}/product-feed/${feedType}`,
      payload,
      { ...axiosConfig, headers: { ...axiosConfig?.headers, ...headers } },
    );
    return data;
  }
}
